import { setWithQuotaRecovery } from 'utils/storageQuota/setWithQuotaRecovery'
import type { TResponseCacheEntry } from './_types'

/**
 * Never rejects. A cache write failing has to degrade into a cache miss rather
 * than a failed request, since the caller already has its response by this point.
 */
export const setResponseCacheEntry = async (key: string, entry: TResponseCacheEntry): Promise<void> => {
  await setWithQuotaRecovery(key, entry, { storageOperation: 'setResponseCacheEntry' })
}
